import React, { useState } from 'react'
import classNames from 'classnames'

import Image from '../ui/Image/Image'
import EventsModal from '../EventsModal/EventsModal'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import { getImageUrl, isArabic } from '../../utils'

import styles from './EventsCard.module.scss'
import Arrow from '../../assets/images/arrow.svg'
import Images from '../../assets/images/Images.png'

const EventsCard = ({ data }) => {
  const { language } = useLanguage()
  const [openModal, setOpenModal] = useState(false)
  const [modalData, setModalData] = useState({})

  const handleView = () => {
    setOpenModal(true)
    setModalData(data)
  }

  const closeModal = () => {
    setOpenModal(false)
  }

  return (
    <>
      <div className={styles['card-container']}>
        <div
          className={classNames(
            styles['top-container'],
            'absolute left-0 top-0 flex items-start bg-white gap-1',
            { [styles.arabicTopContainer]: isArabic(language.code) }
          )}
        >
          <img
            src={Images}
            alt="Images"
            className={classNames(styles.images)}
          />
          <div className={classNames(styles['top-content'])}>
            {data?.image?.length}
          </div>
        </div>
        <div
          className={classNames(
            'flex h-full w-full',
            styles['image-container']
          )}
        >
          {data?.image?.slice(0, 1)?.map((item) => {
            return (
              <Image
                src={getImageUrl(item)}
                className={classNames(
                  'justify-self-center align-self-center',
                  styles['thumbnail-image']
                )}
                alt={item?.alternativeText}
                key={item?.id}
              />
            )
          })}
        </div>
        <div
          className={classNames(
            'absolute bottom-0 left-0 w-full flex items-end justify-between',
            styles['bottom-container']
          )}
        >
          <div
            className={classNames(styles['bottom-content'], {
              [styles['arabic-bottom-content']]: isArabic(language?.code),
            })}
          >
            {data?.eventfilter?.label}
          </div>
          <div
            className={classNames(
              styles['animated-action-wrapper'],
              'bg-white relative',
              {
                [styles['arabic-animated-action-wrapper']]: isArabic(
                  language?.code
                ),
              }
            )}
          >
            <img
              src={Arrow}
              alt="Arrow"
              className={classNames(
                styles['action-image'],
                'block cursor-pointer'
              )}
              onClick={handleView}
            />
          </div>
        </div>
      </div>
      <EventsModal open={openModal} data={modalData} setOpen={closeModal} />
    </>
  )
}

export default EventsCard
